<template>
  <!-- Banner -->
  <section class="banner">
    <div class="container-fluid">
    <div class="row">
      <div class="col-12 col-sm-6 col-md-5 col-lg-5">
      <article class="content mb-80 bar-style">
        <h1>Retirement calculator </h1>
        <p>The calculator below estimates the size of pension needed to fund a person’s retirements across various countries</p>
      </article>
      </div>
      <div class="col-12 col-sm-6 col-md-7 col-lg-8 banner-figure-cont">
      <figure class="banner-figure"></figure>
      </div>
    </div>
    </div>
  </section>
  <!-- Banner area -->
</template>

<script>
export default {
  name: 'Banner',
}
</script>
